export default __webpack_public_path__ + "static/media/CYLEX.f1bcf7cf.png";